const validationRole = (route, role) =>
  role.filter((userRoles) => {
    if (route.meta.roles.some((routeRoles) => routeRoles === userRoles)) {
      return userRoles;
    }
  });

export default validationRole;
